import { render } from "./Campaign.vue?vue&type=template&id=26060d86&scoped=true&ts=true"
import script from "./Campaign.vue?vue&type=script&lang=ts"
export * from "./Campaign.vue?vue&type=script&lang=ts"

import "./Campaign.vue?vue&type=style&index=0&id=26060d86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26060d86"]])

export default __exports__